import _slicedToArray from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import { useStore } from "@dp/state";
import { observer } from "mobx-react-lite";
import { ORDER_TYPES } from "@dp/common";
import Head from "next/head";
import { PageLayout } from "../../util/constants";
import { useHeaderHeight } from "@dp/xcomp";

var NoSlugs = function NoSlugs() {
  var headerHeight = useHeaderHeight();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Head, {
      children: /*#__PURE__*/_jsx("meta", {
        name: "viewport",
        content: "width=device-width, initial-scale=1, maximum-scale=1.0, user-scalable=no"
      })
    }), /*#__PURE__*/_jsx("div", {
      style: {
        height: "calc(100vh - ".concat(headerHeight, ")")
      }
    })]
  });
};

var MenuDetail = dynamic(function () {
  return import("@dp/xcomp").then(function (mod) {
    return mod.MenuItemDetails;
  });
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("@dp/xcomp")];
    },
    modules: ["menu/index.tsx -> " + "@dp/xcomp"]
  }
});
var MenuListing = dynamic(function () {
  return import("@dp/xcomp").then(function (mod) {
    return mod.MenuListing;
  });
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("@dp/xcomp")];
    },
    modules: ["menu/index.tsx -> " + "@dp/xcomp"]
  }
});

function _getSlugs(pathWithQueryParams) {
  var slugs = [];
  var queryParams = "";
  var effectivePath = pathWithQueryParams.replace("/menu", "");

  if (effectivePath.indexOf("?") !== -1) {
    var _effectivePath$split = effectivePath.split("?"),
        _effectivePath$split2 = _slicedToArray(_effectivePath$split, 2),
        _slugs = _effectivePath$split2[0],
        _query = _effectivePath$split2[1];

    slugs = _slugs.split("/");
    queryParams = _query.length && "?".concat(_query);
  } else {
    slugs = effectivePath.split("/");
  }

  return {
    slugs: slugs.filter(function (f) {
      return f.length > 0;
    }),
    queryParams: queryParams
  };
}

var MenuRoutePage = function MenuRoutePage(_ref) {
  var _store$menuList, _store$menuList2, _store$menuList2$menu, _store$menuList2$menu2, _store$menuList3, _store$menuList3$menu, _store$menuList4, _store$menuList4$menu, _store$menuList5, _store$menuList5$menu, _store$menuList6, _store$menuList6$appA, _store$menuList6$appA2, _store$menuList7, _store$menuList7$menu, _store$menuList17;

  var brand = _ref.brand;
  var router = useRouter(); // ["foo", "bar"]

  var _useState = useState(null),
      slugClassifier = _useState[0],
      setSlugClassifier = _useState[1];

  var _useState2 = useState(true),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var store = useStore();
  var lastSlug = null;

  var _getSlugs2 = _getSlugs(router.asPath),
      slug = _getSlugs2.slugs,
      queryParams = _getSlugs2.queryParams;

  var menuList = store === null || store === void 0 ? void 0 : (_store$menuList = store.menuList) === null || _store$menuList === void 0 ? void 0 : _store$menuList.menuList;
  if (slug !== null && (slug === null || slug === void 0 ? void 0 : slug.length) >= 2) lastSlug = slug.pop();
  var categories = store === null || store === void 0 ? void 0 : (_store$menuList2 = store.menuList) === null || _store$menuList2 === void 0 ? void 0 : (_store$menuList2$menu = _store$menuList2.menuListModel) === null || _store$menuList2$menu === void 0 ? void 0 : (_store$menuList2$menu2 = _store$menuList2$menu.menuListData) === null || _store$menuList2$menu2 === void 0 ? void 0 : _store$menuList2$menu2.categories;
  var orderType = store === null || store === void 0 ? void 0 : (_store$menuList3 = store.menuList) === null || _store$menuList3 === void 0 ? void 0 : (_store$menuList3$menu = _store$menuList3.menuListModel) === null || _store$menuList3$menu === void 0 ? void 0 : _store$menuList3$menu.orderType;
  var defaultCategoryCode = store === null || store === void 0 ? void 0 : (_store$menuList4 = store.menuList) === null || _store$menuList4 === void 0 ? void 0 : (_store$menuList4$menu = _store$menuList4.menuListModel) === null || _store$menuList4$menu === void 0 ? void 0 : _store$menuList4$menu.defaultCategoryCode;
  var currentCategoryCode = store === null || store === void 0 ? void 0 : (_store$menuList5 = store.menuList) === null || _store$menuList5 === void 0 ? void 0 : (_store$menuList5$menu = _store$menuList5.menuListModel) === null || _store$menuList5$menu === void 0 ? void 0 : _store$menuList5$menu.currentCategoryCode;
  var brandCode = store === null || store === void 0 ? void 0 : (_store$menuList6 = store.menuList) === null || _store$menuList6 === void 0 ? void 0 : (_store$menuList6$appA = _store$menuList6.appAttributes) === null || _store$menuList6$appA === void 0 ? void 0 : (_store$menuList6$appA2 = _store$menuList6$appA.concept) === null || _store$menuList6$appA2 === void 0 ? void 0 : _store$menuList6$appA2.conceptCodeDesc;
  var menuItem = store === null || store === void 0 ? void 0 : (_store$menuList7 = store.menuList) === null || _store$menuList7 === void 0 ? void 0 : (_store$menuList7$menu = _store$menuList7.menuDetailModel) === null || _store$menuList7$menu === void 0 ? void 0 : _store$menuList7$menu.menuItem;
  var restaurantNum = router.query.setRestaurant;
  var menuListStore = store === null || store === void 0 ? void 0 : store.menuList;
  var orderTypeFromUrl = router.query.orderType;
  var restaurantId = router.query.restID;
  var id = router.query.id;
  var source = router.query.source;
  var kind = router.query.kind;
  var clearCart = router.query.clearCart;

  var getPageTilte = function getPageTilte(_currentCategoryCode) {
    if (_currentCategoryCode) {
      var itemName = _currentCategoryCode.split("-").join(" ").toUpperCase();

      return "".concat(itemName, " | Menu | ").concat(brandCode);
    }

    return "Menu";
  };

  var getMenuDetailPageTilte = function getMenuDetailPageTilte() {
    if (menuItem !== null && menuItem !== void 0 && menuItem.name) {
      var categoryCode = (menuItem === null || menuItem === void 0 ? void 0 : menuItem.breadCrumbSlug.split("/")[0]) || "";
      var splitCategoryName = categoryCode.split("-").join(" ");
      var category = splitCategoryName.charAt(0).toUpperCase() + splitCategoryName.slice(1);
      return "".concat(menuItem === null || menuItem === void 0 ? void 0 : menuItem.name, " | ").concat(category, " | ").concat(brandCode);
    }

    return "Menu Item";
  };

  useEffect(function () {
    var abTestHandler = function abTestHandler() {
      var _store$menuList8, _store$menuList8$sear;

      var isMenuSearchDisabled = window["WEB_MENU_SEARCH_DISABLE"] || false;
      store === null || store === void 0 ? void 0 : (_store$menuList8 = store.menuList) === null || _store$menuList8 === void 0 ? void 0 : (_store$menuList8$sear = _store$menuList8.searchModel) === null || _store$menuList8$sear === void 0 ? void 0 : _store$menuList8$sear.setMenuSearchABTest(isMenuSearchDisabled);
    };

    window.addEventListener("ABTestEvent", abTestHandler);
    return function () {
      window.removeEventListener("ABTestEvent", function () {
        return abTestHandler;
      });
    };
  }, []);
  useEffect(function () {
    var handleRouteChange = function handleRouteChange(url, _ref2) {
      var shallow = _ref2.shallow;

      try {
        var _store$menuList9, _store$menuList10, _store$menuList10$sea, _store$menuList11, _store$menuList11$men, _store$menuList12, _store$menuList12$men, _store$menuList13, _store$menuList14, _store$menuList14$car;

        if (!(store !== null && store !== void 0 && (_store$menuList9 = store.menuList) !== null && _store$menuList9 !== void 0 && _store$menuList9.isLocationSelectionMandatory)) {
          store.menuList.orderSettingsModel.showRestaurantSearchModal = false;
        }

        if (store !== null && store !== void 0 && (_store$menuList10 = store.menuList) !== null && _store$menuList10 !== void 0 && (_store$menuList10$sea = _store$menuList10.searchModel) !== null && _store$menuList10$sea !== void 0 && _store$menuList10$sea.showSearchModal) {
          var _store$platformUtil;
          /**
           * nav added because if already visited PDP via search
           * and came back using View Menu CTA
           * that route remain in history and then clicking on browser back opens PDP
           **/


          store === null || store === void 0 ? void 0 : (_store$platformUtil = store.platformUtil) === null || _store$platformUtil === void 0 ? void 0 : _store$platformUtil.navigateToRoute("/menu");
          store.menuList.searchModel.showSearchModal = false;
          store.menuList.searchModel.searchInputBoxText = "";
          store.menuList.searchModel.searchText = "";
        }

        store === null || store === void 0 ? void 0 : (_store$menuList11 = store.menuList) === null || _store$menuList11 === void 0 ? void 0 : (_store$menuList11$men = _store$menuList11.menuListModel) === null || _store$menuList11$men === void 0 ? void 0 : _store$menuList11$men.toggleShowQuickAddMenuCustomizationModal(false);
        store === null || store === void 0 ? void 0 : (_store$menuList12 = store.menuList) === null || _store$menuList12 === void 0 ? void 0 : (_store$menuList12$men = _store$menuList12.menuListModel) === null || _store$menuList12$men === void 0 ? void 0 : _store$menuList12$men.setCurrentAddToCartLoadingItemID(null);
        store === null || store === void 0 ? void 0 : (_store$menuList13 = store.menuList) === null || _store$menuList13 === void 0 ? void 0 : _store$menuList13.cartModel.setIsAddToCartLoading(false);
        store === null || store === void 0 ? void 0 : (_store$menuList14 = store.menuList) === null || _store$menuList14 === void 0 ? void 0 : (_store$menuList14$car = _store$menuList14.cartModel) === null || _store$menuList14$car === void 0 ? void 0 : _store$menuList14$car.toggleEditMenuCustomizationModal(false);
        store.menuList.orderSettingsModel.showOrderSettingsConfirmationModal = false;
      } catch (e) {
        console.log(e);
      }
    };

    router.events.on("routeChangeStart", handleRouteChange);
    return function () {
      router.events.off("routeChangeStart", handleRouteChange);
    };
  }, []);
  useEffect(function () {
    var _store$menuList15, _store$menuList16;

    if (store !== null && store !== void 0 && (_store$menuList15 = store.menuList) !== null && _store$menuList15 !== void 0 && _store$menuList15.isLocationSelectionMandatory && !(store !== null && store !== void 0 && (_store$menuList16 = store.menuList) !== null && _store$menuList16 !== void 0 && _store$menuList16.escapeLocationSelectionForDIPO)) {
      store.menuList.orderSettingsModel.showRestaurantSearchModal = true;
      store.menuList.dispatchInitialUserLocationModal();
    }
  }, [store === null || store === void 0 ? void 0 : (_store$menuList17 = store.menuList) === null || _store$menuList17 === void 0 ? void 0 : _store$menuList17.isLocationSelectionMandatory]);
  useEffect(function () {
    if (restaurantNum && menuListStore) {
      menuListStore.selectRestaurant("", restaurantNum, false);
    }
  }, [restaurantNum, menuListStore]);
  useEffect(function () {
    if (orderTypeFromUrl === "dinein" && restaurantId) {
      var _store$dineInOrder;

      store === null || store === void 0 ? void 0 : (_store$dineInOrder = store.dineInOrder) === null || _store$dineInOrder === void 0 ? void 0 : _store$dineInOrder.initiateDineInOrder(restaurantId, id, source, kind, clearCart);
    }
  }, [orderTypeFromUrl, restaurantId, menuListStore]);
  useEffect(function () {
    //if (!router.isReady) return;
    store.initComponent("Menu").then(function () {
      if (lastSlug && menuList) {
        var classifier = store.menuList.isMenuOrSubCategory(lastSlug);
        setSlugClassifier(classifier);
        setLoading(false);
      }

      if (!lastSlug) {
        setLoading(false);
      }
    });
  }, [lastSlug, menuList]);
  useEffect(function () {
    var catering = categories === null || categories === void 0 ? void 0 : categories.find(function (_c) {
      return _c.code === "catering";
    });
    if (slug.length || !categories || !categories.length) return;

    if ((orderType === ORDER_TYPES.CATERING_DELIVERY || orderType === ORDER_TYPES.CATERING_PICKUP) && catering) {
      router.push("/menu/".concat(catering.code, "/").concat(queryParams));
    } else {
      var _categories$;

      defaultCategoryCode ? router.push("/menu/".concat(defaultCategoryCode, "/").concat(queryParams)) : router.push("/menu/".concat(categories === null || categories === void 0 ? void 0 : (_categories$ = categories[0]) === null || _categories$ === void 0 ? void 0 : _categories$.code, "/").concat(queryParams));
    }
  }, [categories, orderType, slug, defaultCategoryCode]);

  var getComp = function getComp() {
    var _getSlugs3 = _getSlugs(router.asPath),
        slug = _getSlugs3.slugs,
        queryParams = _getSlugs3.queryParams;

    if (slug === null) {
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsxs(Head, {
          children: [/*#__PURE__*/_jsx("title", {
            children: "Menu"
          }), /*#__PURE__*/_jsx("meta", {
            name: "viewport",
            content: "width=device-width, initial-scale=1, maximum-scale=1.0, user-scalable=no"
          })]
        }), /*#__PURE__*/_jsx(MenuListing, {
          name: "Menu",
          queryParmas: queryParams
        })]
      });
    } else if (!slug.length) {
      return /*#__PURE__*/_jsx(NoSlugs, {});
    } else if ((slug === null || slug === void 0 ? void 0 : slug.length) === 1) {
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsxs(Head, {
          children: [/*#__PURE__*/_jsx("title", {
            children: getPageTilte(currentCategoryCode)
          }), /*#__PURE__*/_jsx("meta", {
            name: "viewport",
            content: "width=device-width, initial-scale=1, maximum-scale=1.0, user-scalable=no"
          })]
        }), /*#__PURE__*/_jsx(MenuListing, {
          name: "Menu",
          anchorSlug: slug.join("/"),
          queryParmas: queryParams
        })]
      });
    } else if ((slug === null || slug === void 0 ? void 0 : slug.length) === 2 && slugClassifier) {
      if (slugClassifier === "MENU") {
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsxs(Head, {
            children: [/*#__PURE__*/_jsx("title", {
              children: getMenuDetailPageTilte()
            }), menuItem !== null && menuItem !== void 0 && menuItem.seoMetaDescription ? /*#__PURE__*/_jsx("meta", {
              name: "description",
              content: menuItem === null || menuItem === void 0 ? void 0 : menuItem.seoMetaDescription
            }) : null, /*#__PURE__*/_jsx("meta", {
              name: "viewport",
              content: "width=device-width, initial-scale=1, maximum-scale=1.0, user-scalable=no"
            })]
          }), /*#__PURE__*/_jsx(MenuDetail, {
            name: "Menu",
            menuId: slug[1],
            category: slug[0]
          })]
        });
      } else if (slugClassifier === "CATEGORY") {
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsxs(Head, {
            children: [/*#__PURE__*/_jsx("title", {
              children: getPageTilte(currentCategoryCode)
            }), /*#__PURE__*/_jsx("meta", {
              name: "viewport",
              content: "width=device-width, initial-scale=1, maximum-scale=1.0, user-scalable=no"
            })]
          }), /*#__PURE__*/_jsx(MenuListing, {
            name: "Menu",
            anchorSlug: slug.join("/"),
            queryParmas: queryParams
          })]
        });
      } else {
        return /*#__PURE__*/_jsx(MenuListing, {
          name: "Menu",
          queryParmas: queryParams
        }); //TODO: may be show a 404 page here since the slug was not found
      }
    } else if ((slug === null || slug === void 0 ? void 0 : slug.length) === 3) {
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsxs(Head, {
          children: [/*#__PURE__*/_jsx("title", {
            children: getMenuDetailPageTilte()
          }), menuItem !== null && menuItem !== void 0 && menuItem.seoMetaDescription ? /*#__PURE__*/_jsx("meta", {
            name: "description",
            content: menuItem === null || menuItem === void 0 ? void 0 : menuItem.seoMetaDescription
          }) : null, /*#__PURE__*/_jsx("meta", {
            name: "viewport",
            content: "width=device-width, initial-scale=1, maximum-scale=1.0, user-scalable=no"
          })]
        }), /*#__PURE__*/_jsx(MenuDetail, {
          name: "Menu",
          menuId: slug[2],
          category: slug[0],
          subCategory: slug[1]
        })]
      });
    }

    return /*#__PURE__*/_jsx(MenuListing, {
      name: "Menu",
      queryParmas: queryParams
    });
  };

  if (loading) {
    return /*#__PURE__*/_jsx("div", {
      style: {
        height: "100vh"
      }
    }); // return <></>;
  } else {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: getComp()
    });
  }
};

MenuRoutePage["layout"] = PageLayout.NB_LAYOUT;
export default observer(MenuRoutePage);